'use client';

import { useRef } from "react";
export const useRenderRef = value => {
  const ref = useRef(value);
  ref.current = value;
  return ref;
};